import { 
  FiHome, FiBriefcase, FiLayers, FiPackage, FiUsers, 
  FiFileText, FiShoppingCart, FiBarChart, FiSettings,
  FiBook, FiTrendingUp, FiUser, FiBox, FiChevronDown, FiChevronRight,
  FiDollarSign, FiShield, FiCreditCard, FiPrinter, FiKey, FiShoppingBag, FiRefreshCw, FiGlobe, FiZap, FiAward, FiCalendar, FiCheckCircle, FiRotateCcw, FiDownload, FiArrowRight, FiGrid, FiActivity,
  FiArrowDownCircle, FiArrowUpCircle, FiRadio, FiCloud, FiTag, FiLink, FiDatabase, FiClock, FiEdit, FiLayout, FiDroplet, FiTool, FiClipboard, FiUpload,
  FiCoffee, FiTruck, FiUsers as FiRestUsers, FiMonitor, FiMap, FiList, FiWifi, FiBell, FiAlertTriangle, FiTrash2, FiInfo, FiCpu, FiMapPin, FiNavigation, FiSmartphone, FiCamera, FiInbox, FiPlus, FiMessageSquare, FiGitBranch, FiPercent
} from 'react-icons/fi'

export interface MenuItem {
  path?: string
  label: { ar: string; en: string; fr: string }
  icon?: any
  children?: MenuItem[]
}

export const menuItems: MenuItem[] = [
  // {
  //   label: { ar: 'ستديو التطوير', en: 'Development Studio', fr: 'Studio de Développement' },
  //   icon: FiTool,
  //   children: [
  //     {
  //       path: '/settings/studio',
  //       label: { ar: 'لوحة التحكم', en: 'Dashboard', fr: 'Tableau de bord' },
  //       icon: FiSettings
  //     },
  //     { 
  //       path: '/settings/studio', 
  //       label: { ar: 'منشئ الجداول', en: 'Table Builder', fr: 'Constructeur de Tables' }, 
  //       icon: FiDatabase 
  //     },
  //     { 
  //       path: '/settings/studio', 
  //       label: { ar: 'منشئ الفورمات', en: 'Form Builder', fr: 'Constructeur de Formulaires' }, 
  //       icon: FiEdit 
  //     },
  //     { 
  //       path: '/settings/studio', 
  //       label: { ar: 'منشئ العروض', en: 'View Builder', fr: 'Constructeur de Vues' }, 
  //       icon: FiLayout 
  //     },
  //   ]
  // },
  
  {
    label: { ar: 'العملاء والموردين', en: 'Customers & Vendors', fr: 'Clients et Fournisseurs' },
    icon: FiUsers,
    children: [
      // {
      //   path: '/hr/dashboard',
      //   label: { ar: 'لوحة المعلومات', en: 'Dashboard', fr: 'Tableau de bord' },
      //   icon: FiHome
      // },
      { 
        path: '/customers', 
        label: { ar: 'العملاء', en: 'Customers', fr: 'Clients' }, 
        icon: FiUsers 
      },
      { 
        path: '/vendors', 
        label: { ar: 'الموردين', en: 'Vendors', fr: 'Fournisseurs' }, 
        icon: FiUsers 
      },
    ]
  },
  {
    label: { ar: 'الشركاء والملاك', en: 'Partners & Ownership', fr: 'Associés et propriété' },
    icon: FiPercent,
    children: [
      { path: '/partners/dashboard', label: { ar: 'لوحة الشركاء', en: 'Partners Dashboard', fr: 'Tableau des associés' }, icon: FiHome },
      { path: '/partners', label: { ar: 'الشركاء', en: 'Partners', fr: 'Associés' }, icon: FiUsers },
      { path: '/partners/ownership', label: { ar: 'الملكية', en: 'Ownership', fr: 'Propriété' }, icon: FiPercent },
      { path: '/partners/capital', label: { ar: 'رأس المال', en: 'Capital', fr: 'Capital' }, icon: FiDollarSign },
      { path: '/partners/profit-periods', label: { ar: 'فترات الأرباح', en: 'Profit Periods', fr: 'Périodes de profit' }, icon: FiCalendar },
      { path: '/partners/distributions', label: { ar: 'توزيع الأرباح', en: 'Profit Distribution', fr: 'Distribution' }, icon: FiTrendingUp },
      { path: '/partners/reports', label: { ar: 'تقارير الشركاء', en: 'Partner Reports', fr: 'Rapports' }, icon: FiBarChart },
    ]
  },
  {
    label: { ar: 'المخازن', en: 'Stores', fr: 'Entrepôts' },
    icon: FiBox,
    children: [
      { 
        path: '/stores', 
        label: { ar: 'المخازن', en: 'Stores', fr: 'Entrepôts' }, 
        icon: FiBox 
      },
      { 
        path: '/categories', 
        label: { ar: 'الفئات', en: 'Categories', fr: 'Catégories' }, 
        icon: FiPackage 
      },
      { 
        path: '/items', 
        label: { ar: 'الأصناف', en: 'Items', fr: 'Articles' }, 
        icon: FiPackage 
      },
      { 
        path: '/items/prices-editor', 
        label: { ar: 'تعديل أسعار الأصناف', en: 'Items Prices Editor', fr: 'Éditeur des Prix des Articles' }, 
        icon: FiDollarSign 
      },
      { 
        path: '/items-directory', 
        label: { ar: 'دليل الأصناف', en: 'Items Directory', fr: 'Répertoire des Articles' }, 
        icon: FiPackage 
      },
      // { 
      //   path: '/inventory-transfers/new', 
      //   label: { ar: 'مناقلة المخزون', en: 'Inventory Transfer', fr: 'Transfert d\'Inventaire' }, 
      //   icon: FiFileText 
      // },
      { 
        path: '/branch-transfers', 
        label: { ar: 'مناقلات بين الفروع', en: 'Branch Transfers', fr: 'Transferts entre Succursales' }, 
        icon: FiArrowRight 
      },
      { 
        path: '/inventory-adjustments', 
        label: { ar: 'التسويات الجردية', en: 'Inventory Adjustments', fr: 'Ajustements d\'Inventaire' }, 
        icon: FiRefreshCw 
      },
      { 
        path: '/periodic-inventory/close', 
        label: { ar: 'إقفال الجرد الدوري', en: 'Periodic Inventory Close', fr: 'Clôture d\'Inventaire Périodique' }, 
        icon: FiCalendar 
      },
      { 
        path: '/inventory/smart-stock-take', 
        label: { ar: 'تطبيق الجرد', en: 'Inventory Count', fr: 'Inventaire physique' }, 
        icon: FiClipboard 
      },
      { 
        path: '/opening-stock-invoices', 
        label: { ar: 'مخزون أول المدة', en: 'Opening Stock', fr: 'Stock d\'Ouverture' }, 
        icon: FiPackage 
      },
      {
        path: '/inventory/cost-repair',
        label: { ar: 'إصلاح التكاليف', en: 'Cost Repair Engine', fr: 'Moteur de réparation des coûts' },
        icon: FiTool
      },
      {
        path: '/inventory/document-repair',
        label: { ar: 'إصلاح قيود ومخزون المستندات', en: 'Document Journal Repair', fr: 'Réparation des écritures' },
        icon: FiAlertTriangle
      },
      // { 
      //   path: '/medicines', 
      //   label: { ar: 'تتبع الأدوية', en: 'Medicine Tracking', fr: 'Suivi des Médicaments' }, 
      //   icon: FiActivity 
      // },
      { 
        path: '/barcode-print', 
        label: { ar: 'طباعة الباركود', en: 'Barcode Printing', fr: 'Impression de Codes-Barres' }, 
        icon: FiPrinter 
      },
      { 
        path: '/modifiers', 
        label: { ar: 'إدارة المعدلات (إضافات، بدون)', en: 'Modifiers Management', fr: 'Gestion des Modificateurs' }, 
        icon: FiList 
      },
      { 
        path: '/stock-adjustment', 
        label: { ar: 'تسوية المخزون', en: 'Stock Adjustment', fr: 'Ajustement de Stock' }, 
        icon: FiRefreshCw 
      },
      // {
      //   label: { ar: 'المخازن المتقدمة', en: 'Advanced Warehouse', fr: 'Entrepôt Avancé' },
      //   icon: FiDatabase,
      //   children: [
      //     {
      //       path: '/warehouse-bins',
      //       label: { ar: 'إدارة المواقع (Bins)', en: 'Bin Management', fr: 'Gestion des Emplacements' },
      //       icon: FiGrid
      //     },
      //     {
      //       path: '/item-bin-links',
      //       label: { ar: 'ربط الأصناف بالمواقع', en: 'Item Bin Linking', fr: 'Liaison Article-Emplacement' },
      //       icon: FiLink
      //     }
      //   ]
      // }
    ]
  },
  {
    label: { ar: 'الحسابات', en: 'Accounts', fr: 'Comptes' },
    icon: FiBook,
    children: [
      { 
        path: '/chart-of-accounts', 
        label: { ar: 'دليل الحسابات', en: 'Chart of Accounts', fr: 'Plan Comptable' }, 
        icon: FiBook 
      },
      { 
        path: '/cost-centers', 
        label: { ar: 'مراكز التكلفة', en: 'Cost Centers', fr: 'Centres de Coût' }, 
        icon: FiBook 
      },
      // { 
      //   path: '/budgets', 
      //   label: { ar: 'الميزانيات', en: 'Budgets', fr: 'Budgets' }, 
      //   icon: FiDollarSign 
      // },
      { 
        path: '/operation-types', 
        label: { ar: 'أنواع القيود', en: 'Operation Types', fr: 'Types d\'Opérations' }, 
        icon: FiBook 
      },
      { 
        path: '/journal', 
        label: { ar: 'القيود', en: 'Journal', fr: 'Journal' }, 
        icon: FiBarChart 
      },
      { 
        path: '/all-journal-entries', 
        label: { ar: 'كل القيود', en: 'All Journal Entries', fr: 'Toutes les Écritures' }, 
        icon: FiActivity 
      },
      { 
        path: '/recurring-journal-entries', 
        label: { ar: 'القيود الدورية', en: 'Recurring Journal Entries', fr: 'Écritures Récurrentes' }, 
        icon: FiRefreshCw 
      },
      { 
        path: '/bank-reconciliation', 
        label: { ar: 'التسويات البنكية', en: 'Bank Reconciliation', fr: 'Rapprochement bancaire' }, 
        icon: FiLink 
      },
      { 
        path: '/vouchers', 
        label: { ar: 'سندات القبض والصرف', en: 'Vouchers', fr: 'Bons' }, 
        icon: FiCreditCard 
      },
    ]
  },
  {
    label: { ar: 'الأصول الثابتة', en: 'Fixed Assets', fr: 'Immobilisations' },
    icon: FiPackage,
    children: [
      {
        path: '/fixed-assets',
        label: { ar: 'قائمة الأصول', en: 'Assets List', fr: 'Liste des immobilisations' },
        icon: FiPackage
      },
      {
        path: '/fixed-assets/capital-maintenance',
        label: { ar: 'الصيانة الرأسمالية', en: 'Capital Maintenance', fr: 'Maintenance capitalisable' },
        icon: FiTool
      },
      {
        path: '/fixed-assets/routine-maintenance',
        label: { ar: 'الصيانة الدورية', en: 'Routine Maintenance', fr: 'Maintenance périodique' },
        icon: FiRefreshCw
      },
      {
        path: '/fixed-assets/sales',
        label: { ar: 'بيع الأصول', en: 'Asset Sales', fr: 'Cession d\'actifs' },
        icon: FiShoppingCart
      },
      {
        path: '/fixed-assets/reports/routine-expenses',
        label: { ar: 'مصروفات الصيانة الدورية', en: 'Routine Expenses Report', fr: 'Rapport des dépenses périodiques' },
        icon: FiBarChart
      },
    ]
  },
  // ملاحظة: تم الإبقاء على مجموعة المناقصات الموحدة لاحقاً في الملف لتجنب التكرار
  // {
  //   label: { ar: 'تأجير السيارات', en: 'Car Rental', fr: 'Location de voitures' },
  //   icon: FiTruck,
  //   children: [
  //     {
  //       path: '/car-rental/dashboard',
  //       label: { ar: 'لوحة التحكم', en: 'Dashboard', fr: 'Tableau de bord' },
  //       icon: FiHome
  //     },
  //     {
  //       path: '/car-rental/cars',
  //       label: { ar: 'السيارات', en: 'Cars', fr: 'Voitures' },
  //       icon: FiTruck
  //     },
  //     {
  //       path: '/car-rental/car-types',
  //       label: { ar: 'أنواع السيارات', en: 'Car Types', fr: 'Types de voitures' },
  //       icon: FiLayers
  //     },
  //     {
  //       path: '/car-rental/contracts',
  //       label: { ar: 'عقود التأجير', en: 'Rental Contracts', fr: 'Contrats de location' },
  //       icon: FiFileText
  //     },
  //     {
  //       path: '/car-rental/payments',
  //       label: { ar: 'المدفوعات', en: 'Payments', fr: 'Paiements' },
  //       icon: FiCreditCard
  //     },
  //     {
  //       path: '/car-rental/maintenance',
  //       label: { ar: 'الصيانة', en: 'Maintenance', fr: 'Entretien' },
  //       icon: FiTool
  //     }
  //   ]
  // },
  {
    label: { ar: 'الموارد البشرية', en: 'Human Resources', fr: 'Ressources Humaines' },
    icon: FiUsers,
    children: [
      {
        path: '/hr/employees',
        label: { ar: 'الموظفين', en: 'Employees', fr: 'Employés' },
        icon: FiUsers
      },
      {
        path: '/hr/departments',
        label: { ar: 'الهيكل التنظيمي', en: 'Departments', fr: 'Départements' },
        icon: FiLayers
      },
      {
        path: '/hr/job-profiles',
        label: { ar: 'المسميات الوظيفية', en: 'Job Profiles', fr: 'Profils de Poste' },
        icon: FiBriefcase
      },
      {
        path: '/hr/contracts',
        label: { ar: 'العقود', en: 'Contracts', fr: 'Contrats' },
        icon: FiFileText
      },
      {
        path: '/hr/leave-requests',
        label: { ar: 'الإجازات', en: 'Leave Requests', fr: 'Demandes de Congé' },
        icon: FiCalendar
      },
      {
        path: '/hr/attendance',
        label: { ar: 'الحضور والانصراف', en: 'Attendance', fr: 'Assiduité' },
        icon: FiClock
      },
      {
        path: '/hr/attendance-app',
        label: { ar: 'تطبيق الحضور (GPS)', en: 'Attendance App (GPS)', fr: 'App présence (GPS)' },
        icon: FiNavigation
      },
      {
        path: '/hr/attendance-sites',
        label: { ar: 'مواقع العمل', en: 'Work Sites', fr: 'Sites de travail' },
        icon: FiMapPin
      },
      {
        path: '/hr/attendance-app-devices',
        label: { ar: 'أجهزة تطبيق الحضور', en: 'App Phones', fr: 'Téléphones app' },
        icon: FiSmartphone
      },
      {
        path: '/hr/attendance-devices',
        label: { ar: 'أجهزة البصمة', en: 'Fingerprint Devices', fr: 'Pointeuses' },
        icon: FiCpu
      },
      {
        path: '/hr/attendance-punches',
        label: { ar: 'سجل البصمات والبريك', en: 'Punches & Breaks', fr: 'Pointages et pauses' },
        icon: FiCoffee
      },
      {
        path: '/hr/attendance-policies',
        label: { ar: 'سياسات الحضور والجزاءات', en: 'Attendance Policies & Penalties', fr: 'Politiques de présence & pénalités' },
        icon: FiSettings
      },
      {
        path: '/hr/work-schedules',
        label: { ar: 'الورديات والجداول', en: 'Work Schedules', fr: 'Horaires de Travail' },
        icon: FiClock
      },
      {
        path: '/hr/employee-work-schedules',
        label: { ar: 'تعيين جداول الموظفين', en: 'Employee Assignments', fr: 'Affectations Employés' },
        icon: FiClock
      },
      {
        path: '/hr/time-entries',
        label: { ar: 'ساعات العمل', en: 'Time Entries', fr: 'Heures de Travail' },
        icon: FiClock
      },
      {
        path: '/hr/employee-advances',
        label: { ar: 'الموظفين والسلف', en: 'Employees & Advances', fr: 'Employés et Avances' },
        icon: FiDollarSign
      },
      {
        path: '/hr/payroll',
        label: { ar: 'مسير الرواتب', en: 'Payroll', fr: 'Paie' },
        icon: FiDollarSign
      }
    ]
  },
  // {
  //   label: { ar: 'وحدة البلدية', en: 'Municipality Module', fr: 'Module Municipalité' },
  //   icon: FiBriefcase,
  //   children: [
  //     {
  //       label: { ar: 'الخدمات والشكاوى', en: 'Services & Complaints', fr: 'Services & Réclamations' },
  //       icon: FiFileText,
  //       children: [
  //         { 
  //           path: '/municipality/complaints', 
  //           label: { ar: 'شكاوى المواطنين', en: 'Citizen Complaints', fr: 'Plaintes des citoyens' }, 
  //           icon: FiFileText 
  //         },
  //         { 
  //           path: '/municipality/complaint-types', 
  //           label: { ar: 'أنواع الشكاوى', en: 'Complaint Types', fr: 'Types de plaintes' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/municipality/service-requests', 
  //           label: { ar: 'طلبات الخدمات', en: 'Service Requests', fr: 'Demandes de service' }, 
  //           icon: FiFileText 
  //         },
  //         { 
  //           path: '/municipality/service-types', 
  //           label: { ar: 'أنواع الخدمات', en: 'Service Types', fr: 'Types de services' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/municipality/services', 
  //           label: { ar: 'الخدمات البلدية', en: 'Municipality Services', fr: 'Services municipaux' }, 
  //           icon: FiBriefcase 
  //         },
  //         { 
  //           path: '/municipality/citizens', 
  //           label: { ar: 'المواطنين', en: 'Citizens', fr: 'Citoyens' }, 
  //           icon: FiUser 
  //         },
  //         { 
  //           path: '/municipality/departments', 
  //           label: { ar: 'أقسام البلدية', en: 'Departments', fr: 'Départements' }, 
  //           icon: FiUsers 
  //         },
  //         { 
  //           path: '/municipality/export-to-online', 
  //           label: { ar: 'ارسال البيانات من سمارت الى online', en: 'Export Data to Online', fr: 'Exporter les données en ligne' }, 
  //           icon: FiCloud 
  //         },
  //       ]
  //     },
  //     {
  //       label: { ar: 'الوحدات السكنية', en: 'Housing Units', fr: 'Unités d\'Habitation' },
  //       icon: FiGrid,
  //       children: [
  //         { 
  //           path: '/municipality/housing-units', 
  //           label: { ar: 'الوحدات السكنية', en: 'Housing Units', fr: 'Unités d\'Habitation' }, 
  //           icon: FiGrid 
  //         },
  //         { 
  //           path: '/municipality/housing-unit-types', 
  //           label: { ar: 'أنواع الوحدات', en: 'Unit Types', fr: 'Types d\'Unités' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/municipality/housing-unit-usage-types', 
  //           label: { ar: 'الاستخدام الموسمي', en: 'Seasonal Usage', fr: 'Usage saisonnier' }, 
  //           icon: FiRadio 
  //         },
  //         { 
  //           path: '/municipality/housing-unit-relations', 
  //           label: { ar: 'علاقات المالك/المستأجر', en: 'Owner/Tenant Relations', fr: 'Relations propriétaire/locataire' }, 
  //           icon: FiLink 
  //         },
  //       ]
  //     },
  //     {
  //       label: { ar: 'المجلس واللجان', en: 'Council & Committees', fr: 'Conseil & Commissions' },
  //       icon: FiUsers,
  //       children: [
  //         { 
  //           path: '/municipality/council-members', 
  //           label: { ar: 'أعضاء المجلس', en: 'Council Members', fr: 'Membres du conseil' }, 
  //           icon: FiUsers 
  //         },
  //         { 
  //           path: '/municipality/committees', 
  //           label: { ar: 'اللجان', en: 'Committees', fr: 'Commissions' }, 
  //           icon: FiBriefcase 
  //         },
  //         { 
  //           path: '/municipality/committee-members', 
  //           label: { ar: 'أعضاء اللجان', en: 'Committee Members', fr: 'Membres des commissions' }, 
  //           icon: FiUsers 
  //         },
  //         { 
  //           path: '/municipality/committee-tasks', 
  //           label: { ar: 'مهام اللجان', en: 'Committee Tasks', fr: 'Tâches des commissions' }, 
  //           icon: FiCheckCircle 
  //         },
  //         { 
  //           path: '/municipality/committee-meetings', 
  //           label: { ar: 'اجتماعات اللجان', en: 'Committee Meetings', fr: 'Réunions des commissions' }, 
  //           icon: FiCalendar 
  //         },
  //         { 
  //           path: '/municipality/committee-reports', 
  //           label: { ar: 'تقارير اللجان', en: 'Committee Reports', fr: 'Rapports des commissions' }, 
  //           icon: FiFileText 
  //         },
  //         { 
  //           path: '/municipality/council-president-elections', 
  //           label: { ar: 'انتخابات الرئيس', en: 'President Elections', fr: 'Élections du président' }, 
  //           icon: FiAward 
  //         },
  //       ]
  //     },
  //     {
  //       label: { ar: 'المشاريع', en: 'Projects', fr: 'Projets' },
  //       icon: FiBriefcase,
  //       children: [
  //         { 
  //           path: '/municipality/project-requests', 
  //           label: { ar: 'طلبات المشاريع', en: 'Project Requests', fr: 'Demandes de projet' }, 
  //           icon: FiFileText 
  //         },
  //         { 
  //           path: '/municipality/project-types', 
  //           label: { ar: 'أنواع المشاريع', en: 'Project Types', fr: 'Types de projets' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/municipality/projects', 
  //           label: { ar: 'المشاريع البلدية', en: 'Municipality Projects', fr: 'Projets municipaux' }, 
  //           icon: FiBriefcase 
  //         },
  //         { 
  //           path: '/municipality/project-tasks', 
  //           label: { ar: 'مهام المشاريع', en: 'Project Tasks', fr: 'Tâches de projet' }, 
  //           icon: FiCheckCircle 
  //         },
  //         { 
  //           path: '/municipality/project-expenses', 
  //           label: { ar: 'مصروفات المشاريع', en: 'Project Expenses', fr: 'Dépenses de projet' }, 
  //           icon: FiDollarSign 
  //         },
  //       ]
  //     },
  //     {
  //       label: { ar: 'الإيرادات والتراخيص', en: 'Revenues & Licenses', fr: 'Revenus & Licences' },
  //       icon: FiDollarSign,
  //       children: [
  //         { 
  //           path: '/municipality/revenues', 
  //           label: { ar: 'الجبايات', en: 'Revenues', fr: 'Revenus' }, 
  //           icon: FiDollarSign 
  //         },
  //         { 
  //           path: '/municipality/collection/commercial', 
  //           label: { ar: 'جباية المحلات التجارية', en: 'Commercial Collection', fr: 'Collection Commerciale' }, 
  //           icon: FiShoppingBag 
  //         },
  //         { 
  //           path: '/municipality/revenue-types', 
  //           label: { ar: 'أنواع الجبايات', en: 'Revenue Types', fr: 'Types de Revenus' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/municipality/licenses', 
  //           label: { ar: 'التراخيص', en: 'Licenses', fr: 'Licences' }, 
  //           icon: FiFileText 
  //         },
  //         { 
  //           path: '/municipality/license-types', 
  //           label: { ar: 'أنواع التراخيص', en: 'License Types', fr: 'Types de Licences' }, 
  //           icon: FiTag 
  //         },
  //       ]
  //     },
  //     { 
  //       path: '/municipality/online-sync', 
  //       label: { ar: 'سحب دفعات Online', en: 'Pull Online Payments', fr: 'Importer paiements Online' }, 
  //       icon: FiRefreshCw 
  //     },
  //     {
  //       label: { ar: 'الوثائق الرسمية', en: 'Official Documents', fr: 'Documents officiels' },
  //       icon: FiFileText,
  //       children: [
  //         { 
  //           path: '/municipality/official-documents', 
  //           label: { ar: 'الوثائق', en: 'Documents', fr: 'Documents' }, 
  //           icon: FiFileText 
  //         },
  //         { 
  //           path: '/municipality/official-document-types', 
  //           label: { ar: 'أنواع الوثائق', en: 'Document Types', fr: 'Types de documents' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/municipality/official-document-templates', 
  //           label: { ar: 'نماذج الوثائق', en: 'Document Templates', fr: 'Modèles de documents' }, 
  //           icon: FiLayout 
  //         },
  //       ]
  //     },
  //     {
  //       label: { ar: 'الرواتب', en: 'Salaries', fr: 'Salaires' },
  //       icon: FiDollarSign,
  //       children: [
  //         { 
  //           path: '/municipality/salaries', 
  //           label: { ar: 'رواتب الموظفين', en: 'Salaries', fr: 'Salaires' }, 
  //           icon: FiUsers 
  //         },
  //         { 
  //           path: '/municipality/salary-types', 
  //           label: { ar: 'أنواع بنود الرواتب', en: 'Salary Types', fr: 'Types de Salaires' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/municipality/employee-advances', 
  //           label: { ar: 'سلف الموظفين', en: 'Employee Advances', fr: 'Avances Employés' }, 
  //           icon: FiDollarSign 
  //         },
  //       ]
  //     },
  //     {
  //       label: { ar: 'الموظفون', en: 'Employees', fr: 'Employés' },
  //       icon: FiUsers,
  //       children: [
  //         { 
  //           path: '/municipality/employees', 
  //           label: { ar: 'موظفو البلدية', en: 'Municipality Employees', fr: 'Employés municipaux' }, 
  //           icon: FiUsers 
  //         },
  //         { 
  //           path: '/employee-tasks', 
  //           label: { ar: 'مهام الموظفين', en: 'Employee Tasks', fr: 'Tâches des employés' }, 
  //           icon: FiCheckCircle 
  //         },
  //         { 
  //           path: '/municipality/employee-salary-profiles', 
  //           label: { ar: 'ملفات الرواتب', en: 'Salary Profiles', fr: 'Profils de paie' }, 
  //           icon: FiDollarSign 
  //         },
  //         { 
  //           path: '/municipality/employee-salary-changes', 
  //           label: { ar: 'تغييرات الرواتب', en: 'Salary Changes', fr: 'Changements de paie' }, 
  //           icon: FiActivity 
  //         },
  //       ]
  //     },
  //     {
  //       label: { ar: 'الأصول', en: 'Assets', fr: 'Actifs' },
  //       icon: FiPackage,
  //       children: [
  //         { 
  //           path: '/municipality/assets', 
  //           label: { ar: 'أصول البلدية', en: 'Municipality Assets', fr: 'Actifs municipaux' }, 
  //           icon: FiPackage 
  //         },
  //       ]
  //     },
  //     {
  //       label: { ar: 'الوحدة المالية', en: 'Finance Module', fr: 'Module Finance' },
  //       icon: FiDollarSign,
  //       children: [
  //         { 
  //           path: '/municipality/finance-revenues', 
  //           label: { ar: 'إيرادات مالية', en: 'Finance Revenues', fr: 'Revenus Financiers' }, 
  //           icon: FiArrowDownCircle 
  //         },
  //         { 
  //           path: '/municipality/finance-expenses', 
  //           label: { ar: 'نفقات مالية', en: 'Finance Expenses', fr: 'Dépenses Financières' }, 
  //           icon: FiArrowUpCircle 
  //         },
  //         { 
  //           path: '/municipality/finance-revenue-types', 
  //           label: { ar: 'أنواع الإيرادات', en: 'Revenue Types', fr: 'Types de Revenus' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/municipality/finance-expense-types', 
  //           label: { ar: 'أنواع النفقات', en: 'Expense Types', fr: 'Types de Dépenses' }, 
  //           icon: FiTag 
  //         },
  //       ]
  //     },
  //     {
  //       label: { ar: 'الموازنة', en: 'Budgeting', fr: 'Budgétisation' },
  //       icon: FiBook,
  //       children: [
  //         { 
  //           path: '/municipality/budgets', 
  //           label: { ar: 'الموازنات', en: 'Budgets', fr: 'Budgets' }, 
  //           icon: FiBook 
  //         },
  //         { 
  //           path: '/municipality/budget-lines', 
  //           label: { ar: 'بنود الموازنة', en: 'Budget Lines', fr: 'Lignes Budgétaires' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/municipality/budget-transfers', 
  //           label: { ar: 'تحويلات البنود', en: 'Budget Transfers', fr: 'Transferts Budgétaires' }, 
  //           icon: FiRefreshCw 
  //         },
  //         { 
  //           path: '/municipality/budget-transactions', 
  //           label: { ar: 'تنفيذ الموازنة', en: 'Budget Transactions', fr: 'Transactions Budgétaires' }, 
  //           icon: FiActivity 
  //         },
  //       ]
  //     },
  //     {
  //       label: { ar: 'الإنجازات', en: 'Achievements', fr: 'Réalisations' },
  //       icon: FiAward,
  //       children: [
  //         { 
  //           path: '/municipality/achievements', 
  //           label: { ar: 'إنجازات البلدية', en: 'Municipality Achievements', fr: 'Réalisations municipales' }, 
  //           icon: FiAward 
  //         },
  //         { 
  //           path: '/municipality/achievement-attachments', 
  //           label: { ar: 'مرفقات الإنجازات', en: 'Achievement Attachments', fr: 'Pièces jointes' }, 
  //           icon: FiFileText 
  //         },
  //       ]
  //     },
  //     {
  //       label: { ar: 'التقارير', en: 'Reports', fr: 'Rapports' },
  //       icon: FiBarChart,
  //       children: [
  //         { 
  //           path: '/reports/municipality-full', 
  //           label: { ar: 'تقرير البلدية الشامل', en: 'Municipality Full Report', fr: 'Rapport Municipal Complet' }, 
  //           icon: FiFileText 
  //         },
  //         { 
  //           path: '/reports/municipality/complaints', 
  //           label: { ar: 'تقرير الشكاوى', en: 'Complaints Report', fr: 'Rapport des plaintes' }, 
  //           icon: FiFileText 
  //         },
  //         { 
  //           path: '/reports/municipality/complaint-types', 
  //           label: { ar: 'تقرير أنواع الشكاوى', en: 'Complaint Types Report', fr: 'Types de plaintes' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/reports/municipality/service-requests', 
  //           label: { ar: 'تقرير طلبات الخدمات', en: 'Service Requests Report', fr: 'Demandes de service' }, 
  //           icon: FiFileText 
  //         },
  //         { 
  //           path: '/reports/municipality/service-types', 
  //           label: { ar: 'تقرير أنواع الخدمات', en: 'Service Types Report', fr: 'Types de services' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/reports/municipality/services', 
  //           label: { ar: 'تقرير الخدمات البلدية', en: 'Services Report', fr: 'Services municipaux' }, 
  //           icon: FiBriefcase 
  //         },
  //         { 
  //           path: '/reports/municipality/departments', 
  //           label: { ar: 'تقرير الأقسام', en: 'Departments Report', fr: 'Départements' }, 
  //           icon: FiUsers 
  //         },
  //         { 
  //           path: '/reports/municipality/citizens', 
  //           label: { ar: 'تقرير المواطنين', en: 'Citizens Report', fr: 'Citoyens' }, 
  //           icon: FiUser 
  //         },
  //         { 
  //           path: '/reports/municipality-neighborhood-citizens', 
  //           label: { ar: 'تقرير المواطنين حسب الحي', en: 'Neighborhood Citizens Report', fr: 'Rapport des citoyens par quartier' }, 
  //           icon: FiHome 
  //         },
  //         { 
  //           path: '/reports/municipality/council-members', 
  //           label: { ar: 'تقرير أعضاء المجلس', en: 'Council Members Report', fr: 'Membres du conseil' }, 
  //           icon: FiUsers 
  //         },
  //         { 
  //           path: '/reports/municipality/committees', 
  //           label: { ar: 'تقرير اللجان', en: 'Committees Report', fr: 'Commissions' }, 
  //           icon: FiUsers 
  //         },
  //         { 
  //           path: '/reports/municipality/committee-members', 
  //           label: { ar: 'تقرير أعضاء اللجان', en: 'Committee Members Report', fr: 'Membres des commissions' }, 
  //           icon: FiUsers 
  //         },
  //         { 
  //           path: '/reports/municipality/committee-tasks', 
  //           label: { ar: 'تقرير مهام اللجان', en: 'Committee Tasks Report', fr: 'Tâches des commissions' }, 
  //           icon: FiCheckCircle 
  //         },
  //         { 
  //           path: '/reports/municipality/committee-meetings', 
  //           label: { ar: 'تقرير اجتماعات اللجان', en: 'Committee Meetings Report', fr: 'Réunions des commissions' }, 
  //           icon: FiCalendar 
  //         },
  //         { 
  //           path: '/reports/municipality/committee-reports', 
  //           label: { ar: 'تقرير تقارير اللجان', en: 'Committee Reports', fr: 'Rapports des commissions' }, 
  //           icon: FiFileText 
  //         },
  //         { 
  //           path: '/reports/municipality/projects', 
  //           label: { ar: 'تقرير المشاريع', en: 'Projects Report', fr: 'Projets' }, 
  //           icon: FiBriefcase 
  //         },
  //         { 
  //           path: '/reports/municipality/project-types', 
  //           label: { ar: 'تقرير أنواع المشاريع', en: 'Project Types Report', fr: 'Types de projets' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/reports/municipality/project-requests', 
  //           label: { ar: 'تقرير طلبات المشاريع', en: 'Project Requests Report', fr: 'Demandes de projet' }, 
  //           icon: FiFileText 
  //         },
  //         { 
  //           path: '/reports/municipality/project-tasks', 
  //           label: { ar: 'تقرير مهام المشاريع', en: 'Project Tasks Report', fr: 'Tâches de projet' }, 
  //           icon: FiCheckCircle 
  //         },
  //         { 
  //           path: '/reports/municipality/project-expenses', 
  //           label: { ar: 'تقرير مصروفات المشاريع', en: 'Project Expenses Report', fr: 'Dépenses de projet' }, 
  //           icon: FiDollarSign 
  //         },
  //         { 
  //           path: '/reports/municipality/revenues', 
  //           label: { ar: 'تقرير الجبايات', en: 'Revenues Report', fr: 'Revenus' }, 
  //           icon: FiDollarSign 
  //         },
  //         { 
  //           path: '/reports/municipality/revenue-types', 
  //           label: { ar: 'تقرير أنواع الجبايات', en: 'Revenue Types Report', fr: 'Types de revenus' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/reports/municipality/licenses', 
  //           label: { ar: 'تقرير التراخيص', en: 'Licenses Report', fr: 'Licences' }, 
  //           icon: FiFileText 
  //         },
  //         { 
  //           path: '/reports/municipality/license-types', 
  //           label: { ar: 'تقرير أنواع التراخيص', en: 'License Types Report', fr: 'Types de licences' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/reports/municipality/official-documents', 
  //           label: { ar: 'تقرير الوثائق الرسمية', en: 'Official Documents Report', fr: 'Documents officiels' }, 
  //           icon: FiFileText 
  //         },
  //         { 
  //           path: '/reports/municipality/official-document-types', 
  //           label: { ar: 'تقرير أنواع الوثائق', en: 'Document Types Report', fr: 'Types de documents' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/reports/municipality/official-document-templates', 
  //           label: { ar: 'تقرير نماذج الوثائق', en: 'Document Templates Report', fr: 'Modèles de documents' }, 
  //           icon: FiLayout 
  //         },
  //         { 
  //           path: '/reports/municipality/salaries', 
  //           label: { ar: 'تقرير الرواتب', en: 'Salaries Report', fr: 'Salaires' }, 
  //           icon: FiDollarSign 
  //         },
  //         { 
  //           path: '/reports/municipality/salary-types', 
  //           label: { ar: 'تقرير أنواع بنود الرواتب', en: 'Salary Types Report', fr: 'Types de salaires' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/reports/municipality/employees', 
  //           label: { ar: 'تقرير الموظفين', en: 'Employees Report', fr: 'Employés' }, 
  //           icon: FiUsers 
  //         },
  //         { 
  //           path: '/reports/municipality/employee-salary-profiles', 
  //           label: { ar: 'تقرير ملفات الرواتب', en: 'Salary Profiles Report', fr: 'Profils de paie' }, 
  //           icon: FiDollarSign 
  //         },
  //         { 
  //           path: '/reports/municipality/employee-salary-changes', 
  //           label: { ar: 'تقرير تغييرات الرواتب', en: 'Salary Changes Report', fr: 'Changements de paie' }, 
  //           icon: FiActivity 
  //         },
  //         { 
  //           path: '/reports/municipality/assets', 
  //           label: { ar: 'تقرير الأصول', en: 'Assets Report', fr: 'Actifs' }, 
  //           icon: FiPackage 
  //         },
  //         { 
  //           path: '/reports/municipality/asset-categories', 
  //           label: { ar: 'تقرير فئات الأصول', en: 'Asset Categories Report', fr: 'Catégories d’actifs' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/reports/municipality/budgets', 
  //           label: { ar: 'تقرير الموازنات', en: 'Budgets Report', fr: 'Budgets' }, 
  //           icon: FiBook 
  //         },
  //         { 
  //           path: '/reports/municipality/budget-lines', 
  //           label: { ar: 'تقرير بنود الموازنة', en: 'Budget Lines Report', fr: 'Lignes budgétaires' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/reports/municipality/budget-transfers', 
  //           label: { ar: 'تقرير تحويلات البنود', en: 'Budget Transfers Report', fr: 'Transferts budgétaires' }, 
  //           icon: FiRefreshCw 
  //         },
  //         { 
  //           path: '/reports/municipality/budget-transactions', 
  //           label: { ar: 'تقرير تنفيذ الموازنة', en: 'Budget Transactions Report', fr: 'Transactions budgétaires' }, 
  //           icon: FiActivity 
  //         },
  //         { 
  //           path: '/reports/municipality/achievements', 
  //           label: { ar: 'تقرير الإنجازات', en: 'Achievements Report', fr: 'Réalisations' }, 
  //           icon: FiAward 
  //         },
  //         { 
  //           path: '/reports/municipality/achievement-attachments', 
  //           label: { ar: 'تقرير مرفقات الإنجازات', en: 'Achievement Attachments', fr: 'Pièces jointes' }, 
  //           icon: FiFileText 
  //         },
  //         { 
  //           path: '/reports/municipality/council-president-elections', 
  //           label: { ar: 'تقرير انتخابات الرئيس', en: 'President Elections', fr: 'Élections du président' }, 
  //           icon: FiAward 
  //         },
  //         { 
  //           path: '/reports/municipality/housing-units', 
  //           label: { ar: 'تقرير الوحدات السكنية', en: 'Housing Units Report', fr: 'Unités d’habitation' }, 
  //           icon: FiGrid 
  //         },
  //         { 
  //           path: '/reports/municipality/housing-unit-types', 
  //           label: { ar: 'تقرير أنواع الوحدات', en: 'Housing Unit Types Report', fr: 'Types d’unités' }, 
  //           icon: FiTag 
  //         },
  //         { 
  //           path: '/reports/municipality/housing-unit-usage-types', 
  //           label: { ar: 'تقرير الاستخدام الموسمي', en: 'Seasonal Usage Report', fr: 'Usage saisonnier' }, 
  //           icon: FiRadio 
  //         },
  //         { 
  //           path: '/reports/municipality/housing-unit-relations', 
  //           label: { ar: 'تقرير علاقات الوحدات', en: 'Housing Relations Report', fr: 'Relations d’unités' }, 
  //           icon: FiLink 
  //         },
  //       ]
  //     },
  //   ]
  // },
  {
    label: { ar: 'إدارة المبيعات', en: 'Sales Management', fr: 'Gestion des Ventes' },
    icon: FiShoppingCart,
    children: [
      { 
        path: '/invoices', 
        label: { ar: 'الفواتير', en: 'Invoices', fr: 'Factures' }, 
        icon: FiFileText 
      },
      {
        path: '/invoices/repair-cancelled',
        label: { ar: 'إصلاح الفواتير الملغاة', en: 'Repair cancelled invoices', fr: 'Réparer les factures annulées' },
        icon: FiTool
      },
      { 
        path: '/sales-orders', 
        label: { ar: 'طلبية البيع', en: 'Sales Orders', fr: 'Commandes de Vente' }, 
        icon: FiShoppingBag 
      },
      { 
        path: '/quotations', 
        label: { ar: 'عروض الأسعار', en: 'Quotations', fr: 'Devis' }, 
        icon: FiFileText 
      },
      { 
        path: '/sales-returns', 
        label: { ar: 'مرتجع البيع', en: 'Sales Returns', fr: 'Retours de Vente' }, 
        icon: FiFileText 
      },
      // { 
      //   path: '/book-locations', 
      //   label: { ar: 'أماكن الكتب', en: 'Book Locations', fr: 'Emplacements des Livres' }, 
      //   icon: FiBook 
      // },
      { 
        path: '/loyalty', 
        label: { ar: 'نظام الولاء', en: 'Loyalty System', fr: 'Système de Fidélité' }, 
        icon: FiAward 
      },
      { 
        path: '/promotions', 
        label: { ar: 'العروض والخصومات', en: 'Promotions & Discounts', fr: 'Promotions et Remises' }, 
        icon: FiTag 
      },
      { 
        path: '/sales-reps', 
        label: { ar: 'المندوبين', en: 'Sales Representatives', fr: 'Représentants Commerciaux' }, 
        icon: FiUser 
      },
      { 
        path: '/rep-mobile-requests', 
        label: { ar: 'طلبات المندوبين', en: 'Rep Mobile Requests', fr: 'Demandes Rep Mobile' }, 
        icon: FiBell 
      },
      { 
        path: '/rep-mobile-notifications', 
        label: { ar: 'إشعارات المندوبين', en: 'Rep Notifications', fr: 'Notifications Rep' }, 
        icon: FiAlertTriangle 
      },
      { 
        path: '/sales-reps-map', 
        label: { ar: 'خريطة المندوبين', en: 'Sales Reps Map', fr: 'Carte des reps' }, 
        icon: FiMap 
      },
      { 
        path: '/shifts', 
        label: { ar: 'الورديات', en: 'Shifts', fr: 'Quarts de travail' }, 
        icon: FiClock 
      },
    ]
  },
  {
    label: { ar: 'المتجر الإلكتروني', en: 'Online Store', fr: 'Boutique en ligne' },
    icon: FiShoppingBag,
    children: [
      {
        path: '/commerce',
        label: { ar: 'متاجري', en: 'My stores', fr: 'Mes boutiques' },
        icon: FiShoppingBag
      },
      {
        path: '/commerce/new',
        label: { ar: 'إنشاء متجر جديد', en: 'Create store', fr: 'Créer une boutique' },
        icon: FiPlus
      },
      {
        path: '/commerce/orders',
        label: { ar: 'طلبات المتجر', en: 'Online orders', fr: 'Commandes en ligne' },
        icon: FiShoppingCart
      },
      {
        path: '/commerce/shipping-companies',
        label: { ar: 'شركات الشحن', en: 'Shipping companies', fr: 'Sociétés de livraison' },
        icon: FiTruck
      },
    ]
  }, 
  {
  label: { ar: 'إدارة المشتريات', en: 'Purchase Management', fr: 'Gestion des Achats' },
  icon: FiShoppingBag,
  children: [
    { 
      path: '/purchase-orders', 
      label: { ar: 'طلبية الشراء', en: 'Purchase Orders', fr: 'Bons de Commande' }, 
      icon: FiShoppingBag 
    },
    { 
      path: '/purchase-invoices', 
      label: { ar: 'فاتورة الشراء', en: 'Purchase Invoices', fr: 'Factures d\'Achat' }, 
      icon: FiFileText 
    },
    { 
      path: '/landed-costs', 
      label: { ar: 'تكاليف إضافية على المشتريات', en: 'Landed Costs', fr: 'Coûts additionnels' }, 
      icon: FiTruck 
    },
    { 
      path: '/purchase-returns', 
      label: { ar: 'مرتجع الشراء', en: 'Purchase Returns', fr: 'Retours d\'Achat' }, 
      icon: FiFileText 
    },
  ]
},
  {
    label: { ar: 'نظام الإنتاج', en: 'Production System', fr: 'Système de Production' },
    icon: FiLayers,
    children: [
      { 
        path: '/production/boms', 
        label: { ar: 'وصفات الإنتاج', en: 'Bill of Materials (BOM)', fr: 'Nomenclatures (BOM)' }, 
        icon: FiPackage 
      },
      { 
        path: '/production/orders', 
        label: { ar: 'أوامر الإنتاج', en: 'Production Orders', fr: 'Ordres de Production' }, 
        icon: FiFileText 
      },
      {
        path: '/production/cost-calculations',
        label: { ar: 'احتساب تكلفة الإنتاج', en: 'Production Cost Calculation', fr: 'Calcul du coût de production' },
        icon: FiDollarSign
      },
      { 
        path: '/sorting', 
        label: { ar: 'نظام الفرز (فرز التمور)', en: 'Sorting System', fr: 'Système de Tri' }, 
        icon: FiRefreshCw 
      },
    ]
  },
  {
    label: { ar: 'الضرائب والفوترة', en: 'Taxes & Billing', fr: 'Taxes et Facturation' },
    icon: FiBarChart,
    children: [
      { 
        path: '/taxes', 
        label: { ar: 'الضرائب', en: 'Taxes', fr: 'Taxes' }, 
        icon: FiBarChart 
      },
      { 
        path: '/settings/e-invoice', 
        label: { ar: 'إعدادات الفوترة الإلكترونية', en: 'E-Invoice Settings', fr: 'Paramètres E-Facture' }, 
        icon: FiSettings 
      },
      { 
        path: '/settings/billing-license', 
        label: { ar: 'إعدادات تراخيص الفوترة', en: 'Billing License Settings', fr: 'Paramètres de licence' }, 
        icon: FiKey 
      }
    ]
  },
  // {
  //   label: { ar: 'إدارة الصيانة', en: 'Maintenance Management', fr: 'Gestion de la Maintenance' },
  //   icon: FiTool,
  //   children: [
  //     {
  //       path: '/maintenance/technicians',
  //       label: { ar: 'الفنيين', en: 'Technicians', fr: 'Techniciens' },
  //       icon: FiUsers
  //     },
  //     {
  //       path: '/maintenance/work-orders',
  //       label: { ar: 'أوامر العمل', en: 'Work Orders', fr: 'Ordres de Travail' },
  //       icon: FiClipboard
  //     },
  //     {
  //       path: '/maintenance/settings',
  //       label: { ar: 'إعدادات الصيانة', en: 'Maintenance Settings', fr: 'Paramètres de Maintenance' },
  //       icon: FiSettings
  //     },
  //   ]
  // }, 

  {
    label: { ar: 'التقارير', en: 'Reports', fr: 'Rapports' },
    icon: FiBarChart,
    children: [
      {
        label: { ar: 'التقارير القياسية', en: 'Standard Reports', fr: 'Rapports standard' },
        icon: FiBarChart,
        children: [
      { 
        path: '/reports', 
        label: { ar: 'التقارير', en: 'Reports', fr: 'Rapports' }, 
        icon: FiBarChart 
      },
      { 
        path: '/reports/designer', 
        label: { ar: 'مصمم التقارير', en: 'Report Designer', fr: 'Concepteur de Rapports' }, 
        icon: FiFileText 
      },
      {
        path: '/reports/view-to-report',
        label: { ar: 'تحويل View إلى تقرير', en: 'View To Report', fr: 'Vue vers Rapport' },
        icon: FiDatabase
      },
      { 
        path: '/reports/pivot', 
        label: { ar: 'التقارير التفاعلية (Pivot)', en: 'Interactive Pivot Reports', fr: 'Rapports Pivot Interactifs' }, 
        icon: FiLayers 
      },
      { 
        path: '/reports/detailed-sales', 
        label: { ar: 'تقرير المبيعات التفصيلي', en: 'Detailed Sales Report', fr: 'Rapport Détaillé des Ventes' }, 
        icon: FiBarChart 
      },
      { 
        path: '/reports/dead-stock-tenders', 
        label: { ar: 'تقرير المخزون الراكد للمناقصات', en: 'Dead Stock for Tenders', fr: 'Stock mort pour appels d’offres' }, 
        icon: FiBarChart 
      },
        ]
      },
      {
        label: { ar: 'التقارير الديناميكية', en: 'Dynamic Reports', fr: 'Rapports dynamiques' },
        icon: FiDatabase,
        children: [
          {
            path: '/dynamic-reports',
            label: { ar: 'كل التقارير الديناميكية', en: 'All Dynamic Reports', fr: 'Tous les rapports dynamiques' },
            icon: FiBarChart
          },
          {
            path: '/dynamic-reports/views',
            label: { ar: 'إدارة الـ Views', en: 'Manage Views', fr: 'Gérer les vues' },
            icon: FiDatabase
          },
          {
            path: '/dynamic-reports/new',
            label: { ar: 'إنشاء تقرير', en: 'Create Report', fr: 'Créer un rapport' },
            icon: FiFileText
          },
        ]
      },
    ]
  },
  {
    label: { ar: 'نظام المطاعم والكافيه', en: 'Restaurant & Cafe', fr: 'Restaurant et Café' },
    icon: FiCoffee,
    children: [
      {
        path: '/pos',
        label: { ar: 'كاشير المطعم', en: 'Restaurant POS', fr: 'Caisse Restaurant' },
        icon: FiMonitor
      },
      {
        path: '/tables',
        label: { ar: 'إدارة الطاولات', en: 'Tables Management', fr: 'Gestion des Tables' },
        icon: FiGrid
      },
      {
        path: '/kitchen',
        label: { ar: 'شاشة المطبخ', en: 'Kitchen Display', fr: 'Écran de Cuisine' },
        icon: FiLayout
      },
      {
        path: '/restaurant/delivery',
        label: { ar: 'طلبات التوصيل', en: 'Delivery Orders', fr: 'Commandes de Livraison' },
        icon: FiTruck
      },
      {
        path: '/restaurant/orders-queue',
        label: { ar: 'أرقام الدور والانتظار', en: 'Queue & Token Numbers', fr: 'File d\'attente' },
        icon: FiList
      },
      {
        path: '/restaurant/menu-setup',
        label: { ar: 'إعداد قائمة الطعام', en: 'Menu Setup', fr: 'Configuration du Menu' },
        icon: FiSettings
      },
      {
        path: '/restaurant/expenses',
        label: { ar: 'المصاريف', en: 'Expenses', fr: 'Dépenses' },
        icon: FiDollarSign
      },
      {
        path: '/restaurant/reports',
        label: { ar: 'التقارير', en: 'Reports', fr: 'Rapports' },
        icon: FiBarChart
      }
    ]
  },
  {
    label: { ar: 'التوصيل', en: 'Delivery', fr: 'Livraison' },
    icon: FiTruck,
    children: [
      { path: '/delivery', label: { ar: 'لوحة التوصيل', en: 'Delivery board', fr: 'Tableau livraison' }, icon: FiGrid },
      { path: '/delivery/orders', label: { ar: 'طلبات التوصيل', en: 'Delivery orders', fr: 'Commandes' }, icon: FiList },
      { path: '/delivery/dispatch', label: { ar: 'مركز التوزيع', en: 'Dispatch', fr: 'Répartition' }, icon: FiNavigation },
      { path: '/delivery/driver', label: { ar: 'شاشة السائق', en: 'Driver screen', fr: 'Écran livreur' }, icon: FiSmartphone },
      { path: '/delivery/drivers', label: { ar: 'السائقون', en: 'Drivers', fr: 'Livreurs' }, icon: FiUsers },
      { path: '/delivery/vehicles', label: { ar: 'سيارات التوصيل', en: 'Vehicles', fr: 'Véhicules' }, icon: FiTruck },
      { path: '/delivery/zones', label: { ar: 'مناطق التوصيل', en: 'Zones', fr: 'Zones' }, icon: FiMapPin },
      { path: '/delivery/settlements', label: { ar: 'تسوية السائقين', en: 'Settlements', fr: 'Règlements' }, icon: FiDollarSign },
      { path: '/delivery/reports', label: { ar: 'تقارير التوصيل', en: 'Delivery reports', fr: 'Rapports' }, icon: FiBarChart },
      { path: '/delivery/settings', label: { ar: 'إعدادات التوصيل', en: 'Delivery settings', fr: 'Paramètres' }, icon: FiSettings },
    ]
  },
  {
    label: { ar: 'محطات المحروقات', en: 'Fuel Stations', fr: 'Stations-service' },
    icon: FiDroplet,
    children: [
      {
        path: '/fuel-station/dashboard',
        label: { ar: 'لوحة التحكم', en: 'Dashboard', fr: 'Tableau de bord' },
        icon: FiGrid
      },
      {
        path: '/fuel-station/prices',
        label: { ar: 'التسعيرة اليومية', en: 'Daily prices', fr: 'Prix du jour' },
        icon: FiDollarSign
      },
      {
        path: '/fuel-station/stations',
        label: { ar: 'المحطات', en: 'Stations', fr: 'Stations' },
        icon: FiMapPin
      },
      {
        path: '/fuel-station/master',
        label: { ar: 'الماكينات وعدّادات التعبئة', en: 'Dispensers & Nozzles', fr: 'Distributeurs' },
        icon: FiDroplet
      },
      {
        path: '/fuel-station/readings',
        label: { ar: 'قراءات العدادات', en: 'Meter Readings', fr: 'Relevés' },
        icon: FiList
      },
      {
        path: '/fuel-meter',
        label: { ar: 'تصوير العداد', en: 'Meter Camera', fr: 'Photo compteur' },
        icon: FiCamera
      },
      {
        path: '/fuel-station/deliveries',
        label: { ar: 'استلام المحروقات', en: 'Fuel Receipts', fr: 'Réceptions' },
        icon: FiTruck
      },
      {
        path: '/fuel-station/inventory',
        label: { ar: 'المخزون والتبخير', en: 'Stock & Loss', fr: 'Stock et pertes' },
        icon: FiPackage
      },
      {
        path: '/fuel-station/settlement',
        label: { ar: 'تسوية المخزون', en: 'Stock settlement', fr: 'Régularisation stock' },
        icon: FiClipboard
      },
      {
        path: '/fuel-station/close',
        label: { ar: 'الإغلاق اليومي', en: 'Daily Close', fr: 'Clôture quotidienne' },
        icon: FiCheckCircle
      },
      {
        path: '/fuel-station/daily-sheet',
        label: { ar: 'التقرير اليومي', en: 'Daily sheet', fr: 'Feuille du jour' },
        icon: FiFileText
      },
      {
        path: '/fuel-station/cash',
        label: { ar: 'الصندوق وتحصيل الموظفين', en: 'Cash & attendant collection', fr: 'Caisse et encaissement' },
        icon: FiDollarSign
      },
      {
        path: '/fuel-station/prepaid-coupons',
        label: { ar: 'قسائم مسبقة الدفع', en: 'Prepaid coupons', fr: 'Bons prépayés' },
        icon: FiFileText
      },
      {
        path: '/fuel-station/reports',
        label: { ar: 'التقارير', en: 'Reports', fr: 'Rapports' },
        icon: FiBarChart
      },
      {
        path: '/fuel-station/settings',
        label: { ar: 'الإعدادات والصلاحيات', en: 'Settings & Roles', fr: 'Paramètres' },
        icon: FiSettings
      },
    ]
  },
  // {
  //   label: { ar: 'إدارة عيادة الأسنان', en: 'Dental Clinic Management', fr: 'Gestion Clinique Dentaire' },
  //   icon: FiActivity,
  //   children: [
  //     {
  //       path: '/dental/dashboard',
  //       label: { ar: 'لوحة المعلومات', en: 'Dashboard', fr: 'Tableau de bord' },
  //       icon: FiGrid
  //     },
  //     {
  //       path: '/patients',
  //       label: { ar: 'المرضى', en: 'Patients', fr: 'Patients' },
  //       icon: FiUsers
  //     },
  //     {
  //       path: '/appointments',
  //       label: { ar: 'جدول المواعيد', en: 'Appointments Schedule', fr: 'Calendrier des rendez-vous' },
  //       icon: FiCalendar
  //     },
  //     {
  //       path: '/dental/services',
  //       label: { ar: 'الخدمات والأسعار', en: 'Services & Prices', fr: 'Services et prix' },
  //       icon: FiDollarSign
  //     },
  //     {
  //       path: '/dental/items',
  //       label: { ar: 'تعريف أصناف العيادة', en: 'Clinic items (catalog)', fr: 'Articles clinique' },
  //       icon: FiBox
  //     },
  //     {
  //       path: '/dental/reports',
  //       label: { ar: 'التقارير والإحصائيات', en: 'Reports & Stats', fr: 'Rapports et statistiques' },
  //       icon: FiFileText
  //     },
  //     {
  //       path: '/dental/implants',
  //       label: { ar: 'زراعة الأسنان', en: 'Dental Implants', fr: 'Implants Dentaires' },
  //       icon: FiLayers
  //     },
  //     {
  //       path: '/invoices/dental/new',
  //       label: { ar: 'فاتورة أسنان جديدة', en: 'New Dental Invoice', fr: 'Nouvelle facture dentaire' },
  //       icon: FiFileText
  //     },
  //     {
  //       path: '/invoices/dental/list',
  //       label: { ar: 'قائمة فواتير الأسنان', en: 'Dental Invoices List', fr: 'Liste des factures dentaires' },
  //       icon: FiList
  //     }
  //     // ,
  //     // {
  //     //   path: '/reports/dental',
  //     //   label: { ar: 'تقارير العيادة', en: 'Clinic Reports', fr: 'Rapports Clinique' },
  //     //   icon: FiBarChart
  //     // },
  //   ]
  // },
  // {
  //   label: { ar: 'اشتراكات الخدمة (ISP)', en: 'Service Subscriptions (ISP)', fr: 'Abonnements (FAI)' },
  //   icon: FiWifi,
  //   children: [
  //     {
  //       path: '/subscriptions/dashboard',
  //       label: { ar: 'لوحة الاشتراكات', en: 'Subscriptions dashboard', fr: 'Tableau abonnements' },
  //       icon: FiGrid,
  //     },
  //     {
  //       path: '/subscriptions/packages',
  //       label: { ar: 'الباقات والسرعة/البيانات', en: 'Packages (speed & data)', fr: 'Forfaits débit & données' },
  //       icon: FiLayers,
  //     },
  //     {
  //       path: '/subscriptions/subscribers',
  //       label: { ar: 'ملفات المشتركين', en: 'Subscriber profiles', fr: 'Fiches abonnés' },
  //       icon: FiUsers,
  //     },
  //     {
  //       path: '/subscriptions/contracts',
  //       label: { ar: 'اشتراكات نشطة', en: 'Active subscriptions', fr: 'Abonnements actifs' },
  //       icon: FiCheckCircle,
  //     },
  //     {
  //       path: '/subscriptions/invoices',
  //       label: { ar: 'إيصالات الاشتراكات', en: 'Subscription receipts', fr: 'Reçus abonnement' },
  //       icon: FiFileText,
  //     },
  //     {
  //       path: '/subscriptions/invoices/new',
  //       label: { ar: 'إيصال جديد', en: 'New receipt', fr: 'Nouveau reçu' },
  //       icon: FiFileText,
  //     },
  //     {
  //       path: '/subscriptions/alerts',
  //       label: { ar: 'التنبيهات والجدول', en: 'Alerts schedule', fr: 'Alertes' },
  //       icon: FiBell,
  //     },
  //     {
  //       path: '/subscriptions/tickets',
  //       label: { ar: 'تذاكر الدعم', en: 'Support tickets', fr: 'Tickets support' },
  //       icon: FiClipboard,
  //     },
  //     {
  //       path: '/subscriptions/automation',
  //       label: { ar: 'الأتمتة والتكامل', en: 'Automation & integrations', fr: 'Automatisation' },
  //       icon: FiZap,
  //     },
  //     {
  //       path: '/subscriptions/reports',
  //       label: { ar: 'تقارير الاشتراكات', en: 'Subscription reports', fr: 'Rapports' },
  //       icon: FiBarChart,
  //     },
  //     {
  //       path: '/subscriptions/audit',
  //       label: { ar: 'سجل التدقيق', en: 'Audit log', fr: 'Journal d’audit' },
  //       icon: FiActivity,
  //     },
  //   ],
  // }, 
  // {
  //   label: { ar: 'المناقصات', en: 'Tenders', fr: 'Appels d’offres' },
  //   icon: FiBriefcase,
  //   children: [
  //     { 
  //       path: '/tenders', 
  //       label: { ar: 'قائمة المناقصات', en: 'Tenders', fr: 'Appels d’offres' }, 
  //       icon: FiBriefcase 
  //     },
  //   ]
  // },
  // {
  //   label: { ar: 'النماذج الديناميكية', en: 'Dynamic Forms', fr: 'Formulaires Dynamiques' },
  //   icon: FiLayout,
  //   children: [
  //     { 
  //       path: '/custom-forms', 
  //       label: { ar: 'النماذج', en: 'Forms', fr: 'Formulaires' }, 
  //       icon: FiFileText 
  //     },
  //   ]
  // },
  {
    label: { ar: 'الصلاحيات', en: 'Permissions', fr: 'Autorisations' },
    icon: FiUser,
    children: [
      { 
        path: '/users', 
        label: { ar: 'المستخدمين', en: 'Users', fr: 'Utilisateurs' }, 
        icon: FiUser 
      },
      { 
        path: '/roles', 
        label: { ar: 'الأدوار', en: 'Roles', fr: 'Rôles' }, 
        icon: FiShield 
      },
      { 
        path: '/permissions', 
        label: { ar: 'إدارة الصلاحيات', en: 'Permissions Management', fr: 'Gestion des Autorisations' }, 
        icon: FiShield 
      },
      { 
        path: '/permissions/engine', 
        label: { ar: 'محرك الصلاحيات الديناميكي', en: 'Dynamic Permission Engine', fr: 'Moteur de Permissions' }, 
        icon: FiShield 
      },
      { 
        path: '/permissions/actions', 
        label: { ar: 'الصلاحيات التفصيلية', en: 'Detailed Permissions', fr: 'Autorisations détaillées' }, 
        icon: FiSettings 
      },
      { 
        path: '/audit-logs', 
        label: { ar: 'سجل العمليات', en: 'Audit Logs', fr: 'Journaux d\'Audit' }, 
        icon: FiActivity 
      },
      { 
        path: '/admin/operations', 
        label: { ar: 'مراقبة العمليات المباشرة', en: 'Live Operations Monitor', fr: 'Moniteur en direct' }, 
        icon: FiMonitor 
      },
    ]
  },
  {
    label: { ar: 'إعدادات عامة', en: 'General Settings', fr: 'Paramètres Généraux' },
    icon: FiSettings,
    children: [
      { 
        path: '/settings', 
        label: { ar: 'مركز الإعدادات', en: 'Settings Center', fr: 'Centre des Paramètres' }, 
        icon: FiSettings 
      },
      { 
        path: '/companies', 
        label: { ar: 'الشركات', en: 'Companies', fr: 'Entreprises' }, 
        icon: FiBriefcase 
      },
      { 
        path: '/fiscal-years', 
        label: { ar: 'السنوات المالية', en: 'Fiscal Years', fr: 'Années Fiscales' }, 
        icon: FiCalendar 
      },
      { 
        path: '/branches', 
        label: { ar: 'الفروع', en: 'Branches', fr: 'Succursales' }, 
        icon: FiLayers 
      },
      { 
        path: '/dashboard', 
        label: { ar: 'لوحة التحكم', en: 'Dashboard', fr: 'Tableau de Bord' }, 
        icon: FiHome 
      },
      { 
        path: '/admin/operations', 
        label: { ar: 'مراقبة العمليات', en: 'Operations Monitor', fr: 'Moniteur des opérations' }, 
        icon: FiMonitor 
      },
      { 
        path: '/settings/preferences', 
        label: { ar: 'التفضيلات العامة', en: 'General Preferences', fr: 'Préférences Générales' }, 
        icon: FiSettings 
      },
      { 
        path: '/settings/invoice-settings', 
        label: { ar: 'إعدادات الفواتير', en: 'Invoice Settings', fr: 'Paramètres de Facturation' }, 
        icon: FiSettings 
      },
      { 
        path: '/settings/payment-methods', 
        label: { ar: 'طرق الدفع', en: 'Payment Methods', fr: 'Méthodes de Paiement' }, 
        icon: FiCreditCard 
      },
      {
        path: '/settings/automation',
        label: { ar: 'محرك الأتمتة', en: 'Automation Engine', fr: 'Moteur d\'Automatisme' },
        icon: FiZap
      },
      {
        path: '/settings/dynamic-workflow',
        label: { ar: 'سير العمل الديناميكي', en: 'Dynamic Workflow', fr: 'Workflow dynamique' },
        icon: FiGitBranch
      },
      {
        path: '/settings/dynamic-workflow/monitor',
        label: { ar: 'مراقبة سير العمل', en: 'Workflow Monitor', fr: 'Moniteur de workflow' },
        icon: FiActivity
      },
      {
        path: '/settings/ai-providers',
        label: { ar: 'مزودات الذكاء الاصطناعي', en: 'AI Providers', fr: 'Fournisseurs IA' },
        icon: FiCpu
      },
      {
        path: '/ai',
        label: { ar: 'مركز الذكاء الاصطناعي', en: 'AI Center', fr: 'Centre IA' },
        icon: FiMessageSquare
      },
      {
        path: '/notifications/builder',
        label: { ar: 'منشئ الإشعارات', en: 'Notification Builder', fr: 'Générateur de notifications' },
        icon: FiBell
      },
      {
        path: '/notifications/inbox',
        label: { ar: 'صندوق الإشعارات', en: 'Notification Inbox', fr: 'Boîte de notifications' },
        icon: FiInbox
      },
      {
        path: '/notifications/monitor',
        label: { ar: 'مراقبة الإشعارات', en: 'Notification Monitor', fr: 'Moniteur de notifications' },
        icon: FiActivity
      },
      { 
        path: '/settings/colors', 
        label: { ar: 'ألوان النظام', en: 'System Colors', fr: 'Couleurs du Système' }, 
        icon: FiDroplet 
      },
      { 
        path: '/settings/license', 
        label: { ar: 'إدارة التراخيص', en: 'License Management', fr: 'Gestion des Licences' }, 
        icon: FiKey 
      },
      { 
        path: '/settings/restore-points', 
        label: { ar: 'نقاط الاستعادة', en: 'Restore Points', fr: 'Points de Restauration' }, 
        icon: FiRotateCcw 
      },
      { 
        path: '/settings/database-backup', 
        label: { ar: 'النسخ الاحتياطي لقاعدة البيانات', en: 'Database Backup', fr: 'Sauvegarde de Base de Données' }, 
        icon: FiDatabase 
      },
      { 
        path: '/audit-trail', 
        label: { ar: 'سجل التغييرات', en: 'Audit Trail', fr: 'Journal des Modifications' }, 
        icon: FiActivity 
      },
      { 
        path: '/settings/activity-log', 
        label: { ar: 'سجل النشاطات', en: 'Activity Log', fr: 'Journal des Activités' }, 
        icon: FiActivity 
      },
      { 
        path: '/settings/about', 
        label: { ar: 'حول النظام والتحديثات', en: 'About & Updates', fr: 'À propos et Mises à Jour' }, 
        icon: FiInfo 
      },
      { 
        path: '/settings/schema-comparison', 
        label: { ar: 'مقارنة الموديل وقاعدة البيانات', en: 'Model vs Database', fr: 'Modèle vs Base de données' }, 
        icon: FiDatabase 
      },
      { 
        path: '/settings/updates', 
        label: { ar: 'إدارة التحديثات', en: 'Updates Management', fr: 'Gestion des Mises à Jour' }, 
        icon: FiDownload 
      },
      { 
        path: '/settings/data-integrity', 
        label: { ar: 'فحص وإصلاح البيانات', en: 'Data Integrity Check & Repair', fr: 'Vérification et Réparation de l\'Intégrité des Données' }, 
        icon: FiCheckCircle 
      },
      { 
        path: '/settings/data-management', 
        label: { ar: 'تنظيف وإدارة البيانات', en: 'Data Cleansing & Management', fr: 'Nettoyage et Gestion des Données' }, 
        icon: FiTrash2 
      },
      { 
        path: '/settings/import-system', 
        label: { ar: 'نظام الاستيراد', en: 'Import System', fr: 'Système d\'importation' }, 
        icon: FiUpload 
      },
      { 
        path: '/settings/export-system', 
        label: { ar: 'نظام التصدير', en: 'Export System', fr: 'Système d\'exportation' }, 
        icon: FiDownload 
      },
      { 
        path: '/settings/sql-query', 
        label: { ar: 'مستكشف واستعلام SQL', en: 'SQL Explorer & Query', fr: 'Explorateur SQL' }, 
        icon: FiDatabase 
      },
      { 
        path: '/currencies', 
        label: { ar: 'العملات', en: 'Currencies', fr: 'Devises' }, 
        icon: FiDollarSign 
      },
      { 
        path: '/exchange-rates', 
        label: { ar: 'قائمة صرف العملات', en: 'Exchange Rates', fr: 'Taux de Change' }, 
        icon: FiRefreshCw 
      },
      { 
        path: '/general-attributes', 
        label: { ar: 'خصائص عامة', en: 'General Properties', fr: 'Propriétés Générales' }, 
        icon: FiSettings 
      },
      { 
        path: '/device-sync', 
        label: { ar: 'مزامنة الأجهزة', en: 'Device Sync', fr: 'Synchronisation des Appareils' }, 
        icon: FiCloud 
      },
      {
        path: '/connected-devices',
        label: { ar: 'الأجهزة المتصلة', en: 'Connected Devices', fr: 'Appareils connectés' },
        icon: FiMonitor
      },
      {
        path: '/tailscale-devices',
        label: { ar: 'أجهزة الشبكة — Tailscale', en: 'Tailscale Devices', fr: 'Appareils Tailscale' },
        icon: FiGlobe
      },
      { 
        path: '/signals', 
        label: { ar: 'الإشارات المستلمة', en: 'Received Signals', fr: 'Signaux Reçus' }, 
        icon: FiRadio 
      },
    ]
  },
]
